import { render, staticRenderFns } from "./carportPortList.vue?vue&type=template&id=3fc8bc3e&"
import script from "./carportPortList.vue?vue&type=script&lang=js&"
export * from "./carportPortList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports